export const messages = {
  title: {
    id: 'admin/promotions.form.regular.benefit.title',
  },
}
